import { api } from "./client";

export interface BrandSettingsDto {
  id: string;
  companyName: string;
  tagline: string | null;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  headerFont: string;
  bodyFont: string;
  monoFont: string;
  logoFileName: string | null;
  logoUrl: string | null;
  faviconFileName: string | null;
  faviconUrl: string | null;
  companyAddress: string | null;
  companyPhone: string | null;
  companyEmail: string | null;
  companyWebsite: string | null;
  legalFooter: string | null;
  confidentialityNotice: string | null;
  brandVoiceDescription: string | null;
  documentHeaderHtml: string | null;
  customBrandingJson: string | null;
  modifiedAt: string | null;
  modifiedByUserId: string | null;
  modifiedByDisplayName: string | null;
  /** Native-Phoenix switch for the two private prequalification analysis
   * documents (default off). */
  nativeAnalysisDocsEnabled: boolean;
}

export interface UpdateBrandSettingsPayload {
  companyName: string;
  tagline: string | null;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  headerFont: string;
  bodyFont: string;
  monoFont: string;
  companyAddress: string | null;
  companyPhone: string | null;
  companyEmail: string | null;
  companyWebsite: string | null;
  legalFooter: string | null;
  confidentialityNotice: string | null;
  brandVoiceDescription: string | null;
  documentHeaderHtml: string | null;
  customBrandingJson: string | null;
  nativeAnalysisDocsEnabled: boolean;
}

export interface BrandingGuidePreviewDto {
  text: string;
}

export const brandSettingsApi = {
  get: () => api.get<BrandSettingsDto>("/admin/brand-settings"),
  update: (body: UpdateBrandSettingsPayload) =>
    api.put<BrandSettingsDto>("/admin/brand-settings", body),
  uploadLogo: (file: File) => {
    const form = new FormData();
    form.append("file", file);
    return api.upload<BrandSettingsDto>("/admin/brand-settings/logo", form);
  },
  deleteLogo: () => api.delete<BrandSettingsDto>("/admin/brand-settings/logo"),
  uploadFavicon: (file: File) => {
    const form = new FormData();
    form.append("file", file);
    return api.upload<BrandSettingsDto>("/admin/brand-settings/favicon", form);
  },
  deleteFavicon: () => api.delete<BrandSettingsDto>("/admin/brand-settings/favicon"),
  preview: () => api.get<BrandingGuidePreviewDto>("/admin/brand-settings/preview"),
};
